module.exports = __webpack_public_path__ + "img/beige-clouds.0c75c623.png";